var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3 font-weight-regular body-2",domProps:{"innerHTML":_vm._s(_vm.title)}})
}
var staticRenderFns = []

export { render, staticRenderFns }